import * as yup from "yup"

export const validationSchema = yup.object().shape({
    category_vendor_code: yup.string().label("Category name code").required().max(2, 'Maximum code is 2 characters'),
    category_vendor_name: yup.string().label("Category name name").required().max(100, "Must be 100 characters or less"),
    description: yup.string().label("Category name name").optional()
  })